import * as React from 'react';
import { compose, setDisplayName, withProps } from 'recompose';
import { translate } from 'react-i18next';
import { TranslateProps } from 'util/i18n';
import { skin, OemProps } from 'ui/styles/skin';

import './Section.css';

export type OwnProps = {
    id?: string;
    titleKey?: string;
    title?: string;
    // TODO: onHeightChanged: (h: number) => void;
    embed?: () => void;
    style?: React.CSSProperties;
    children?: React.ReactNode;
};

export const RawSection = ({ id, titleKey = '', title, embed, children, t, styles }: OwnProps & TranslateProps & RecomposeProps) =>
    <section id={ id } style={ styles.section }>
        <header style={ styles.SectionHeader }>
            { (title || titleKey) &&
                <h2>{ title || t(titleKey) }</h2>
            }
            { embed && embed() }
        </header>
        <div className="section-body">
            { children }
        </div>
    </section>
;

type RecomposeProps = {
    styles: { [name: string]: React.CSSProperties };
};

export const Section = compose<OwnProps & TranslateProps & RecomposeProps, OwnProps>(
    setDisplayName('Section'),
    translate(),
    skin,
    withProps(({ style = {}, styles }: OwnProps & OemProps) => ({
        styles: {
            ...styles,
            section: {
                ...styles.Bordered,
                ...styles.Section,
                ...style,
            },
        },
    })),
)(RawSection);



// WEBPACK FOOTER //
// ./src/ui/shared/Section.tsx